import * as Yup from "yup";
import { EmailModel, EmailData } from "../email/EmailModel";

export interface InvoiceEmailData extends EmailData {
  recipients: string[];
}

export const defaultInvoiceEmailData: Readonly<InvoiceEmailData> = {
  htmlText: "",
  subject: "",
  attachments: [],
  recipients: [],
  important: false,
};

export const invoiceEmailSchema = Yup.object().shape({
  htmlText: Yup.string().required("Turinys yra privalomas"),
  subject: Yup.string().required("Laiško tema yra privaloma"),
  recipients: Yup.array<String>().min(
    1,
    "Bent vienas el. pašto adresas yra reikalingas"
  ),
});

export class InvoiceEmailModel extends EmailModel implements InvoiceEmailData {
  recipients: string[] = [];

  constructor(data: Partial<InvoiceEmailData> = {}) {
    super(data);
    this.recipients = data.recipients || defaultInvoiceEmailData.recipients;
  }
}

export default InvoiceEmailModel;
